import { graphql, useStaticQuery } from "gatsby";

export function FormEnterpriseMentorshipQuery() {
    return useStaticQuery(graphql`
        query contentfulFormEnterpriseMentorship {
            form: allContentfulContactenos(
                filter: { contentful_id: { eq: "3dJx2wic07fxaUZlazLpPG" } }
            ) {
                nodes {
                    tituloPrincipal
                    idFormulario
                    tituloFormulario
                    descripcionFormulario {
                        raw
                    }
                    metaTitulo
                    titulosFormulario {
                        tituloGeneral
                        descripcion {
                            raw
                        }
                        referenciaFormulario {
                            tipoCampo
                            listaSelect
                            mensajeError
                            inputPrincipal
                            nombreId
                            tituloBotonTerminos
                            textoTerminos {
                                raw
                            }
                            obligatorio
                            seccion
                            placeholder
                        }
                        tituloBoton
                    }
                }
            }
            modalSuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "43BHjf8X32WP14uB9t3GkV" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }

            modalUnsuccess: allContentfulContactenos(
                filter: { contentful_id: { eq: "3Bboqsnc99i4WbCNaXeiML" } }
            ) {
                nodes {
                    tituloPrincipal
                    descripcionFormulario {
                        raw
                    }
                    descripcion {
                        raw
                    }
                    metaTitulo
                    imagenFormulario {
                        file {
                            url
                        }
                    }
                    tituloBoton
                    redireccionBoton
                    contentful_id
                }
            }
        }
    `);
}